import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetPreferenceResponse,
  PatchBoardPreferenceRequest,
} from '../types';

type ApiEnvelope<T> = { data: T };

export const patchBoardPreference = async <T extends Record<string, unknown>>(
  params: PatchBoardPreferenceRequest<T>,
): Promise<GetPreferenceResponse<T>> => {
  const { boardId, key, data } = params;
  const url = `/api/v2/boards/${boardId}/preferences/${encodeURIComponent(key)}/board`;

  const response = await apiAuthClient.patch<
    ApiEnvelope<GetPreferenceResponse<T>>
  >(url, { data });
  return response.data.data;
};
